export enum UnitType {
  COMPANY = 'COMPANY',
  DEPARTMENT = 'DEPARTMENT',
  BRANCH = 'OKR_BRANCH',
}
